export default "__VITE_ASSET__HZB2GYGd__"